/* global $:false */
(function() {
  'use strict';

  angular
    .module('admin.tips.edit', [
    ])
    .controller('TipsAdminEditCtrl', TipsAdminEditCtrl);

  /** @ngInject */
  function TipsAdminEditCtrl($scope, $state, $stateParams, $timeout, TipsAdminService, CacheService, UploadService) {
    var vm = this;
    vm.model = {};
    vm.pathImgH = '';
    vm.pathImgT = '';
    vm.loadT = false;
    vm.loadH = false;
    vm.id = $stateParams.id;

    if (vm.id !== "0") {
      TipsAdminService.get($stateParams.id).then(function(result){
        if (result.results['img-t'] === undefined) {
          result.results['img-t'] = '';
        }
        if (result.results['img-h'] === undefined) {
          result.results['img-h'] = '';
        }
        vm.model = result.results;
      });
    } else {
      vm.model['img-t'] = '';
      vm.model['img-h'] = '';
    }

    vm.save = function(){
      var model = angular.copy(vm.model);
      delete model.ts;
      delete model['ts-p'];
      if (model.t === undefined || model.txt === undefined) {
        swal('Required title and description fields.', '', 'error');
        return;
      }

      if (model.id !== undefined && model.id !== '' && model.id !== 0) {
        TipsAdminService.update(model.id, model).then(function(){
          $state.go('admin.tips');
        });
      } else {
        TipsAdminService.save(model).then(function(){
          $state.go('admin.tips');
        });
      }
    };

    vm.cancel = function() {
      $state.go('admin.tips');
    };

    vm.uploadT = function(item){
      if (vm.pathImgT.type === 'image/tiff') {
        swal('Unsupported extension', '', 'warning');
        return;
      }
      vm.loadT = true;
      UploadService.save('tips', vm.pathImgT, 'img-t', item.id).then(function(fileName){
        vm.loadT = false;
        item['img-t'] = fileName;
      });
    };

    vm.uploadH = function(item){
      if (vm.pathImgT.type === 'image/tiff') {
        swal('Unsupported extension', '', 'warning');
        return;
      }
      vm.loadH = true;
      UploadService.save('tips', vm.pathImgH, 'img-h', item.id).then(function(fileName){
        vm.loadH = false;
        item['img-h'] = fileName;
      });
    };

    vm.removeImg = function(type, model){
      if (type === 't') {
        model['img-t'] = '';
      } else {
        model['img-h'] = '';
      }
    };
  }

})();
